import { StylovyzeTable, } from '@innovyze/stylovyze/lib/components';
import React from 'react';
import { useSelectCurveManager } from '@innovyze/stylovyze/lib/selectors';
export const CurveManagerDrawerTable = ({ headers, dataCy, }) => {
    const { curveById: { curve }, } = useSelectCurveManager();
    const [curveTableRows, setCurveTableRows] = React.useState([]);
    React.useEffect(() => {
        if (curve) {
            const curveRows = curve?.depthArray.map((depthValue, index) => {
                return {
                    key: index,
                    cells: [depthValue, curve.volumeArray[index]],
                };
            });
            setCurveTableRows(curveRows);
        }
    }, [curve]);
    return (React.createElement(StylovyzeTable, { dataCy: dataCy, headers: headers, rows: curveTableRows }));
};
export default CurveManagerDrawerTable;
